import { getUserData } from "./authnicate";
import { getPermissions, canAccessPage, ROLES } from "../constants/Roles";

// Normalize role string to match ROLES constants (case-insensitive)
const normalizeRole = (role) => {
  if (!role) return null;
  const r = role.toLowerCase();
  if (r === "admin") return ROLES.ADMIN;
  if (r === "spoc") return ROLES.SPOC;
  if (r === "finance") return ROLES.FINANCE;
  return role; // return as-is if unknown
};

// Get the current user's role from localStorage
export const getCurrentRole = () => {
  const user = getUserData();
  if (!user) return null;
  if (Array.isArray(user.roles) && user.roles.length > 0)
    return normalizeRole(user.roles[0]);
  if (user.role) return normalizeRole(user.role);
  return null;
};

// Get permissions object for the current user
export const usePermissions = () => {
  const role = getCurrentRole();
  return getPermissions(role);
};

// Check if current user can access a given page slug
export const useCanAccessPage = (page) => {
  const role = getCurrentRole();
  return canAccessPage(role, page);
};
